/**
 * Safely retrieve a nested value from an object based on an "accessor" path (e.g. 'customer.name').
 */
export function getNestedValue<T extends object>(obj: T, accessor: string): unknown {
  // If there is no object or the object is not actually an object, return null
  if (!obj || typeof obj !== 'object') {
    return null;
  }

  let current: unknown = obj;
  const keys = accessor.split('.');

  for (const key of keys) {
    // If `current` is falsy or not an object, we cannot go deeper
    if (!current || typeof current !== 'object') {
      return null;
    }
    // Narrow `current` to a record so we can index by `key`
    const record = current as Record<string, unknown>;

    if (!(key in record)) {
      return null;
    }

    current = record[key];
  }

  return current;
}
